const jobTypeMappings: { [key: string]: string } = {
    'SOCIAL': 'Social',
    'WALKIN': 'Walk In',
    'PART_TIME': 'Permanent - Part Time',
    'FULL_TIME': 'Permanent - Full Time',
    'CONTRACT': 'Contract'
};

const getMappedJobType = (value: string) => {
    return jobTypeMappings[value] || value || '';
};

export default getMappedJobType;
